import './StoreProducts.css';
import { ProductItem } from './product-item/ProductItem';
import { Button, Dropdown } from '../ui';
import { useStoreProducts } from '../../hooks';
import { ProductItemStatuses } from '../../enums';
import { OrderProviderValue, ProductItemsModel } from '../../models';
import { useContext } from 'react';
import { OrderContext } from '../../contexts/order.context';
import { getLinkWithParams, getTimeAgo } from '../../utils';
import { Link } from 'react-router-dom';

export function StoreProducts(props: { raffles: ProductItemsModel; setRaffles: (raffles: ProductItemsModel) => void; origin: 'store' | 'my-entries' }) {
   const { orders } = useContext<OrderProviderValue>(OrderContext);
   const { raffles, setRaffles, origin } = props;
   const { selectedRaffleStatus, setSelectedRaffleStatus, balance, loadMoreRaffles } = useStoreProducts(raffles, setRaffles);

   return (
      <>
         <div className="flex flex-col gap-3 store-products">
            <div className="store-products-header flex items-center wrap gap justify-between box bg-gray ">
               <h3 className="">{raffles.pagination.total ?? 0} Items</h3>
               <div className="flex start gap-3 items-center">
                  {origin === 'my-entries' && orders.orders && (orders?.orders?.length ?? 0) > 0 && (
                     <div>
                        <h4 className="">
                           Last entry: <span className="green">{getTimeAgo(new Date(orders.orders[0].createdAt))}</span>
                        </h4>
                     </div>
                  )}
                  <Dropdown
                     options={Object.values(ProductItemStatuses)}
                     selectedOption={selectedRaffleStatus}
                     setSelectedOption={setSelectedRaffleStatus}
                  />
               </div>
            </div>

            {raffles.productItems?.map((productItem) => (
               <div
                  className="store-products-item"
                  key={productItem.id}>
                  <ProductItem
                     productItem={productItem}
                     userTickets={balance?.tickets ?? 0}
                     origin={origin}
                     raffles={raffles}
                     setRaffles={setRaffles}
                  />
               </div>
            ))}
         </div>
         {!raffles.productItems ||
            (raffles.productItems?.length === 0 && (
               <div className="flex flex-col items-center justify-center gap-1 pt-3">
                  <h4 className="gray">No {origin === 'store' ? 'Sweepstakes' : 'Entries'} found</h4>
                  {origin === 'my-entries' && (
                     <Link
                        to={getLinkWithParams('/sweepstakes')}
                        className="underline">
                        Buy Entries
                     </Link>
                  )}
               </div>
            ))}
         {(raffles.pagination.total ?? 0) > (raffles?.productItems?.length ?? 0) && (
            <div className="flex justify-center pt-3">
               <Button
                  type="transparent"
                  title="LOAD MORE"
                  onClick={loadMoreRaffles}
               />
            </div>
         )}
      </>
   );
}
